import { BaseIcon } from '@spinwise/react-component-library/BaseIcon';
import { useState } from 'react';
import { IconLibrary } from 'Libraries/icons.library';
import { IconVariantsLibrary } from 'Libraries/variants.library';
import styles from './FaqCard.module.scss';
import parse from 'html-react-parser';

export interface IFaqCard {
  title: string;
  description: string;
}
const FaqCard = (props: IFaqCard) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <div className={styles.faq_container}>
        <div
          className={`${styles.faq_header_cotnainer} d-fl ai-c jc-sb`}
          onClick={() => {
            setIsOpened(!isOpened);
          }}
        >
          <div className={styles.title_container}>
            <p>{props.title}</p>
          </div>
          <div className={styles.icon_container}>
            <div className={isOpened == true ? styles.default_cross : styles.rotated_cross}>
              <BaseIcon iconName={IconLibrary.PlusBold} variant={IconVariantsLibrary.Black} />
            </div>
          </div>
        </div>
        {isOpened == true && (
          <>
            <div className={styles.description_container}>{parse(props.description)}</div>
          </>
        )}
      </div>
    </>
  );
};
export default FaqCard;
